<div mat-dialog-title>
  <div>{{ data.title }}</div>
  <div (click)="onNoClick()" class="close-icon-container">
    <fa-icon [icon]="['far', 'xmark']" class="gray"></fa-icon>
  </div>
</div>
<mat-divider></mat-divider>
<div mat-dialog-content>
  @if (data.question) {
    <p class="eligibility-question-text">
      <span [innerHTML]="data.question"></span>
      @if (infoBoxPlacement === 1) {
        <fa-icon
          [icon]="['far', 'circle-info']"
          class="blue"
          matTooltip="A cord is defined as 128 cubic feet of wood. This measures approximately 4' high x 8' long x 4' deep."
          matTooltipClass="fc-tooltip"
          matTooltipPosition="right"></fa-icon>
      }
      @if (data.redText) {
        <span class="eligibility-question-text red">
          <span [innerHTML]="data.redText"></span>
          @if (infoBoxPlacement === 2) {
            <fa-icon
              #tooltip="matTooltip"
              (click)="tooltip.toggle()"
              [icon]="['far', 'circle-info']"
              class="blue"
              matTooltip="A cord is defined as 128 cubic feet of wood. This measures approximately 4' high x 8' long x 4' deep."
              matTooltipClass="fc-tooltip"
              matTooltipPosition="right"></fa-icon>
          }
        </span>
      }
    </p>
  }
  @if (data.deductionPerYear) {
    <div class="yearly-value first">
      Annual Revenue will be deducted:
      <span class="value">{{ data.deductionPerYear }}</span>
    </div>
  }
</div>
<div class="popup-disclaimer">
  **Approximate reduction value, this could change based on the conditions for your agreement.
</div>
<div mat-dialog-actions>
  @if (data.buttonTextNo) {
    <button
      [mat-dialog-close]="false"
      color="primary"
      data-cy="button-no"
      mat-stroked-button>
      {{ data.buttonTextNo }}
    </button>
  }
  @if (!data.buttonTextNo) {
    <div></div>
  }
  @if (data.buttonTextYes) {
    <button [mat-dialog-close]="true" color="primary" data-cy="button-yes" mat-raised-button>
      {{ data.buttonTextYes }}
    </button>
  }
</div>
